import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { MaturityComplianceRule } from '../models'
import { UpdateMaturityCompliance } from './UpdateMaturityComplianceRule'

interface UpdateMaturityComplianceDrawerProps {
  domain: string
  groupId: number
  maturityComplianceRule: MaturityComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateMaturityComplianceRuleDrawer = ({
  domain,
  groupId,
  maturityComplianceRule,
  isVisible,
  onClose,
  onSuccess,
}: UpdateMaturityComplianceDrawerProps) => {
  return (
    <Drawer
      title="Update Maturity Compliance Rule"
      placement="right"
      open={isVisible}
      onClose={onClose}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <UpdateMaturityCompliance
        domain={domain}
        groupId={groupId}
        maturityComplianceRule={maturityComplianceRule}
        onSuccess={onSuccess}
      />
    </Drawer>
  )
}
